module.exports = __webpack_public_path__ + "static/media/csvEnrichmentSample.de68c19d.csv";